import React, { useEffect } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import "./signup.css";
import { getAPIClient } from "../../apiClient";
import { useBranding } from "../../branding/useBranding";
import { useTranslation } from "react-i18next";
import logout from "../../utils/logout";
import { getAuth } from "firebase/auth";
import { useAtom } from "jotai";

export function SignUpTemplate() {
  const { t } = useTranslation();
  const branding = useBranding();

  return (
    <section className="max-md:overflow-hidden h-svh-w-fallback-and-inset flex items-center justfy-center override-bg-to-neutral">
      <div className="w-full flex justify-center max-md:h-full">
        <div className="card md:max-w-xl md:min-w-xl bg-base-100 md:px-8 max-md:rounded-none max-md:w-full">
          <div className="bg-neutral h-20 w-full md:hidden flex items-center justify-center">
            <img className="dark:hidden h-12" src={`/${branding.headerImage}`} alt="Docket logo" />
            <img
              className="not-dark:hidden h-12"
              src={`/${branding.mobileHeaderImageHighContrast}`}
              alt="Docket logo"
            />
          </div>
          <div className="card-body overflow-scroll">
            <p className="text-center text-3xl font-bold ">{t("onboarding.signup_header")}</p>
            <Outlet />
          </div>
        </div>
      </div>
    </section>
  );
}

export default SignUpTemplate;
